import type { SecurityControlAggregate } from "@app/deploy/security-controls";

/** Matches Security Controls dashboard and print report ordering. */
export const sortSecurityControlAggregates = (
  controls: SecurityControlAggregate[],
  sort: string,
  nameSortDirection: "asc" | "desc",
  statusSortDirection: "asc" | "desc",
): SecurityControlAggregate[] => {
  if (sort === "name") {
    const sortMultiplier = nameSortDirection === "desc" ? -1 : 1;
    return [...controls].sort((a, b) => {
      const diff =
        a.globalControl.name.localeCompare(b.globalControl.name) *
        sortMultiplier;
      if (diff !== 0) return diff;
      return a.cumulativeMetrics.statusSort - b.cumulativeMetrics.statusSort;
    });
  }

  if (sort === "complianceType" || sort === "category") {
    return [...controls].sort((a, b) => {
      const complianceTypeCompare =
        a.globalControl.frameworksAsString.localeCompare(
          b.globalControl.frameworksAsString,
        );
      if (complianceTypeCompare !== 0) return complianceTypeCompare;
      return a.globalControl.name.localeCompare(b.globalControl.name);
    });
  }

  const sortMultiplier = statusSortDirection === "desc" ? -1 : 1;
  return [...controls].sort((a, b) => {
    const diff =
      (a.cumulativeMetrics.statusSort - b.cumulativeMetrics.statusSort) *
      sortMultiplier;
    if (diff !== 0) return diff;
    return a.globalControl.name.localeCompare(b.globalControl.name);
  });
};
